<template>
  <div class="partnershipMobileCardContainer">
    <PartnershipIcons
      :height="partnerIconSizes[partner].height"
      :type="partner"
      :width="partnerIconSizes[partner].width"
    />
    <p class="font-size-12 font-weight-bold text-warning my-2">COMPARE FEATURED SERVICES</p>
    <table class="table">
      <tr
        v-for="{label, values} in authenticatorsTableData"
        :key="label"
      >
        <td class="pl-0">
          <div class="flex-start-center font-weight-bold text-dark text-left">
            {{ label }}
          </div>
        </td>
        <td class="pr-0">
          <div class="flex-col-end-center">
            <span
              v-for="value in values[index]"
              :key="value"
              class="text-dark text-right"
            >
              {{ value }}
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { authenticatorsTableData, partnerIconSizes } from '../constants/authenticatorsConstants';
import PartnershipIcons from './PartnershipIcons';

export default {
  name: 'PartnershipMobileCard',
  components: {
    PartnershipIcons
  },
  props: {
    index: {
      type: String,
      required: true
    },
    partner: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      authenticatorsTableData,
      partnerIconSizes,
      showMore: false
    };
  },
  computed: {
    lessMoreButtonText() {
      return this.showMore ? 'Less' : 'More';
    },
  }
};
</script>

<style lang="scss">
@import '@sass/vue-imports.scss';

.partnershipMobileCardContainer {
  border-radius: 10px;
  box-shadow: 0px 0px 50px rgba(196, 196, 196, 0.5);
  background: #FFF;
  padding: 16px;
  table {
    height: 1px; //sets a height on the table that allows cells to inherit from. actual value is ignored

    tr{
      height: 100%;
      td {
        height: 100%;
        font-size: 14px;

        @media (max-width: 345px) {
          font-size: 12px;
        }

        &:last-of-type {
          width: 50%;
        }
        >div {
          height: 100%;
        }
      }
    }
  }
}
</style>
